import useViewsSelector from "views/stores/useViewsSelector";
import { selectHasUndeclaredParameters } from "views/logic/slices/searchMetadataSelectors";
const useHasUndeclaredParameters = () => useViewsSelector(selectHasUndeclaredParameters);
export default useHasUndeclaredParameters;
